import React, { useState, useEffect, useRef } from 'react';

const AutocompleteInput = ({ suggestions, onSelect, label, value, reset, isEdit }) => {
  const [inputValue, setInputValue] = useState();
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(0);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (inputValue) {
      const filtered = suggestions.filter(
          (suggestion) =>
              suggestion.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      );
      setFilteredSuggestions(filtered);
    } else {
      setFilteredSuggestions(suggestions);
    }
  }, [inputValue, suggestions]);

  useEffect(() => {
    if (value) {
      setInputValue(value);
      onSelect(value);
      reset();
    }
  }, [value]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowSuggestions(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  const handleChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setShowSuggestions(true);
    setActiveSuggestionIndex(0);
    onSelect(value);
  };

  const handleClick = (suggestion) => {
    setInputValue(suggestion);
    setFilteredSuggestions([]);
    setShowSuggestions(false);
    onSelect(suggestion);
  };

  const handleInputClick = (e) => {
    setShowSuggestions(true);
    setActiveSuggestionIndex(0);
  }

  const handleKeyDown = (e) => {
    if (e.keyCode === 38) {
      e.preventDefault();
      if (activeSuggestionIndex === 0) {
        return;
      }
      setActiveSuggestionIndex(activeSuggestionIndex - 1);
    } else if (e.keyCode === 40) {
      e.preventDefault();
      if (activeSuggestionIndex - 1 === filteredSuggestions.length) {
        return;
      }
      setActiveSuggestionIndex(activeSuggestionIndex + 1);
    } else if (e.keyCode === 13) {
      e.preventDefault();
      if (filteredSuggestions.length > 0) {
        const selectedSuggestion = filteredSuggestions[activeSuggestionIndex];
        setInputValue(selectedSuggestion);
        setShowSuggestions(false);
        onSelect(selectedSuggestion);
      }
    }
  };

  return (
      <div className="relative mt-8 float-label-input" ref={wrapperRef}>
        <input
            type="text"
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            onClick={handleInputClick}
            value={inputValue}
            className={`block w-full lg:w-1/2 py-1.5 bg-white outline-none border-b border-solid border-grayBorder ${isEdit ? 'border-formBorder' : 'border-white'}`}
            disabled={!isEdit}
        />
        <label htmlFor="taxoffice" className="absolute top-1.5 left-0 text-gray-400 pointer-events-none transition duration-200 ease-in-outbg-white text-formBorder">{label} *</label>
        {showSuggestions && filteredSuggestions.length > 0 && (
            <ul className="absolute top-8 max-h-60 overflow-y-auto p-2 z-10 bg-white border-2 border-t-white border-solid border-grayBorder cursor-pointer">
              {filteredSuggestions.map((suggestion, index) => (
                  <li
                      key={suggestion}
                      className={`py-1 hover:font-bold ${index === activeSuggestionIndex ? 'font-bold' : ''}`}
                      onClick={() => handleClick(suggestion)}
                  >
                    {suggestion}
                  </li>
              ))}
            </ul>
        )}
      </div>
  );
};

export default AutocompleteInput;